import './admodel.scss'
import component from './component.vue'
var adModal = function (options) {
  InsertDom(options)
  addEvent(options)
  return {
    close: closeAd
  }
}
function closeAd() {
  const div = document.querySelector('.su-mask')
  document.querySelector('body').removeChild(div)
}
function InsertDom(options) {
  const {
    img,
    link = 'javascript:void(0)',
    ad,
    width = '70%',
    hotspot = [],
    content = '',
    hideClose = false
  } = options
  var mask = document.querySelector('#su-zjs-mask') || document.createElement('div')
  mask.style.display = 'flex'
  mask.className = 'su-mask'
  mask.id = 'su-zjs-mask'
  mask.innerHTML = `
	<div class="zjs-advert" style="width:${width}">
        ${content ||
    `<a
          href="${link}"
		  id="adModel_link"
		  class="${ad ? ' outerAd' : ''}"
        >
          <img src="${img}" />
		  ${getHotspotHTML(hotspot)}
        </a>`}
       ${hideClose ? `` :
      `<div class="zjs-advert-close">
          <div>
            <img id="admodel-close" src="https://img.yzcdn.cn/upload_files/2019/11/25/Fs53hUSGrw074xduGjRxvDIQSTYd.png" alt />
          </div>
	  	</div>`}
    </div>
	`
  document.querySelector('body').appendChild(mask)
}
function getHotspotHTML(hotspot) {
  const htmlArr = hotspot.map((item, index) => {
    return `<div class="adModel-hotsopt"  data-hotspot="${index}" style="background:${item.background};left:${item.left}%;right:${item.right}%;top:${item.top}%;bottom:${item.bottom}%;"></div>`
  })
  return htmlArr.join('')
}
function addEvent(callback) {
  // var mask = document.querySelector('#su-zjs-mask')
  const { click = () => false, close = () => false, clickOverlay = true, hotspot = [] } = callback
  const event = [
    {
      selector: '#admodel-close',
      handle: function (e) {
        closeAd()
        close()
        e.stopPropagation()
      }
    },
    {
      selector: '.su-mask',
      handle: function (e) {
        if (clickOverlay) {
          closeAd()
          close()
        }
        e.stopPropagation()
        return false
      }
    },
    {
      selector: '.zjs-advert-close',
      handle: function (e) {
        e.stopPropagation()
      }
    },
    {
      selector: '#adModel_link',
      handle: function (e) {
        if (e.target.dataset.hotspot && e.target.className.indexOf('adModel-hotsopt') > -1) {
          hotspot[e.target.dataset.hotspot].click &&
            hotspot[e.target.dataset.hotspot].click(closeAd)
        } else {
          click(closeAd)
        }
        e.stopPropagation()
      }
    }
  ]
  event.forEach((item) => {
    document.querySelector(item.selector) &&
      document.querySelector(item.selector).removeEventListener('click', item.handle)
  })
  event.forEach((item) => {
    document.querySelector(item.selector) &&
      document.querySelector(item.selector).addEventListener('click', item.handle)
  })
}
component.install = function () {
  window.Vue.component(component.name, component)
}
adModal.component = component
export default adModal
